import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getAnalyticsConsent,
  isAnalyticsConfigured,
  setAnalyticsConsent,
  trackPageView,
} from '../../utils/analytics.js';
import './AnalyticsTracker.css';

export function AnalyticsPageViews() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    trackPageView(pathname, search);
  }, [pathname, search]);
  return null;
}

export function AnalyticsConsentBanner() {
  const [visible, setVisible] = useState(
    () => isAnalyticsConfigured() && !getAnalyticsConsent()
  );

  if (!visible) return null;

  const choose = (granted) => {
    setAnalyticsConsent(granted);
    setVisible(false);
    if (granted) trackPageView(window.location.pathname, window.location.search);
  };

  return (
    <aside className="analytics-consent" aria-label={'\u7db2\u7ad9\u5206\u6790\u8a2d\u5b9a'}>
      <div>
        <strong>{'\u7db2\u7ad9\u5206\u6790'}</strong>
        <p>{'\u6211\u5011\u4f7f\u7528 Google Analytics \u4e86\u89e3\u54ea\u4e9b\u529f\u80fd\u6709\u5e6b\u52a9\uff0c\u4e0d\u6703\u50b3\u9001\u59d3\u540d\u3001\u96fb\u8a71\u3001\u4fe1\u7bb1\u3001\u5730\u5740\u6216\u5e33\u865f\u7b49\u500b\u4eba\u8cc7\u6599\u3002'}</p>
      </div>
      <div className="analytics-consent__actions">
        <button type="button" onClick={() => choose(false)}>{'\u4e0d\u540c\u610f'}</button>
        <button type="button" className="primary" onClick={() => choose(true)}>{'\u540c\u610f'}</button>
      </div>
    </aside>
  );
}
